import React from "react";

import { Col, LinkMoreInfo, Row, Svg } from "components";

interface ScreenSuccessProps {
  children?: React.ReactNode;
  description: string;
  headline: string;
  infoLinkText?: string;
  onInfoLinkClick?: () => void;
  hideCheckmark?: boolean;
}

export const ScreenSuccess = ({ children, description, headline, infoLinkText, onInfoLinkClick, hideCheckmark }: ScreenSuccessProps) => (
  <>
    <Row justify="center" align="middle">
      <Col className="center">{!hideCheckmark && <Svg svgName="misc/success_screen_checkmark" height={124} width={124} />}</Col>
    </Row>
    <Row justify="center" align="middle">
      <Col>
        <h1 className="center">{headline}</h1>
      </Col>
    </Row>
    <Row justify="center" align="middle">
      <Col>
        <p className="margin-bottom-0 center">{description}</p>
      </Col>
    </Row>
    {infoLinkText && onInfoLinkClick ? (
      <Row justify="center" align="middle" className="margin-bottom-400">
        <Col>
          <LinkMoreInfo onClick={onInfoLinkClick}>{infoLinkText}</LinkMoreInfo>
        </Col>
      </Row>
    ) : null}
    {children}
  </>
);
